/**
 * App-wide React Query client.
 *
 * The QueryCache / MutationCache `onError` handlers forward unexpected
 * failures to Sentry via `captureQueryError` (expected user errors are
 * filtered out there), so no data-layer error fails silently.
 */

import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { captureQueryError } from "@/lib/sentry";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => captureQueryError(error, { source: "query" }),
  }),
  mutationCache: new MutationCache({
    onError: (error) => captureQueryError(error, { source: "mutation" }),
  }),
});
